<template>
  <div class="home">
    <MyHeader title="market"></MyHeader>
    <div class="left-bar"></div>
    <div class="right-bar"></div>
    <div class="bottom-bar"></div>
    <div class="content">
      <div class="left">
        <MemberLeft
            ref="barHighTech"
            title="广东省市场主体基本情况"
            subtitle="广东省市场主体总数"
            @handleLink="handleLink"
            @changeCenterPersonName="changeCenterPersonName($event)"
        />
      </div>
      <div class="center">
        <MemberCenter
            ref="memberCenter"
            title="广东省市场主体基本情况"
            subtitle="广东省市场主体总数"
            @handleLink="handleLink"
            :leftPersonSelectPerson="leftSelectPersonName"
        />
      </div>
      <div class="right">
        <MemberRight @handleLink="handleLink" />
      </div>
    </div>
    <div class="o0"></div>
  </div>
</template>

<script>
import { getTime } from '@/utils';
import router from '@/router';
import GzMap from './comp/GzMap';
import TopCountMarket from './comp/TopCountMarket';
import EconomicEntities from './comp/EconomicEntities';
import PrivateEnterprise from './comp/PrivateEnterprise';
import Top500 from './comp/Top500';
import CompanyTop100 from './comp/CompanyTop100';
import ChartBar from './comp/ChartBar';
import ChartBarPlus from './comp/ChartBarPlus.vue';
import ChartMarketRight from './comp/ChartMarketRight.vue';
import GDPAndGrowthRate from './comp/GDP-and-growth-rate';
import FixedAssetInvestment from './comp/fixed-asset-investment';
import EconomicVolume from './comp/economic-volume';
import PrivateEconomy from './comp/PrivateEconomy.vue';
import FinancialService from './comp/FinancialService.vue';
import ScienceTenchnology from './comp/ScienceTenchnology.vue';
import Top100 from './comp/Top100';
import PrivateMigrate from './comp/PrivateMigrate.vue';
import MarketSubjectType from './comp/MarketSubjectType';
import MarketMainIndustry from './comp/MarketMainIndustry.vue';
import SmallMicroEnterprises from './comp/SmallMicroEnterprises.vue';
import Chart3D from './comp/Chart3D';
import ComTable from '../../components/ComTable';
import ElementSelect from '../../components/element-select';
import cityJson from './cityJson';
import MyHeader from '@/components/Header';
import MemberLeft from './comp/MemberLeft';
import MemberRight from './comp/MemberRight';
import MemberCenter from './comp/MemberCenter';
import MemberCenterSecond from './comp/MemberCenterSecond';

export default {
  name: 'Market',
  components: {
    MyHeader,
    ElementSelect,
    ComTable,
    Chart3D,
    ScienceTenchnology,
    Top100,
    PrivateMigrate,
    PrivateEconomy,
    FinancialService,
    MarketSubjectType,
    MarketMainIndustry,
    SmallMicroEnterprises,
    EconomicVolume,
    FixedAssetInvestment,
    GDPAndGrowthRate,
    ChartBar,
    ChartBarPlus,
    ChartMarketRight,
    CompanyTop100,
    Top500,
    PrivateEnterprise,
    EconomicEntities,
    TopCountMarket,
    GzMap,
    MemberLeft,
    MemberRight,
    MemberCenter,
    MemberCenterSecond
  },
  data() {
    return {
      linkParams: {
        dataType: 1,
        year: 2024,
      },
      leftSelectPersonName: ''
    };
  },
  computed: {
  },
  watch: {
    'search.enterpriseName'(n) {
      this.getData();
    },
  },
  mounted() {
    window.onresize = () => {
      this.resizeChart();
    };
  },
  methods: {
    changeCenterPersonName(personName){
      console.log(personName);
      // this.leftSelectPersonName = personName;
      this.$refs.memberCenter.searchByleftPersonSelectPerson(personName);
    },
    handleLink(e) {
      console.log(e);
      this.linkParams = e;
    },
  },
  beforeDestroy() {
    this.$bus.$off('showEn500Dialog');
    // sessionStorage.removeItem('expiredTime');
    // clearInterval(this.timer)
    // clearSetInterval(this.timer1)
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1080px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  .left-bar,
  .right-bar {
    width: 24px;
    height: 899px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: url('~img/market/market-left-bar.png') center center no-repeat;
    background-size: 100%;
  }
  .right-bar {
    left: unset;
    right: 0;
    transform: translateY(-50%) rotateY(180deg);
  }
  .bottom-bar {
    height: 24px;
    width: 2441px;
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 999;
    transform: translateX(-50%);
    background: url('~img/market/market-bottom-bar.png') center center no-repeat;
    background-size: 100%;
  }

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.content {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100% - 96px);
  z-index: 11;

  .center {
    flex: 1;
    position: relative;
    z-index: 1;

    .link {
      position: absolute;
      left: 38px;
      top: 208px;
      font-size: 18px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      text-decoration: underline;
      color: #e9e3b6;
      line-height: 43px;
      font-weight: bold;
      text-shadow: 2px 3px 2px rgba(30, 40, 60, 0.8);
      z-index: 2;
      cursor: pointer;
    }
    .aMap {
      width: calc(100% - 64px);
      position: absolute;
      top: 0;
      left: 32px;
      /*top: 250px;*/
    }

    /*width: 59%;*/
    //  border:1px solid #333;
  }

  .left,
  .right {
    display: flex;
    // z-index: 2;
    flex-wrap: wrap;
    // width: 20%;
    // border:1px solid #333;

    > div:first-child {
      // margin-right: 30px;
    }
  }

  .left {
    // width: 31%;
    width: 1024px;
    padding-left: 32px;
  }

  .right {
    width: 1024px;
    //padding-right: 32px;
    > div {
      width: 100%;
      //height: calc(100% / 3);
    }
    .right-center {
      display: flex;
      > div {
        width: calc(50% - 13px);
        &:first-of-type {
          margin-right: 26px;
        }
        /deep/ .title {
          white-space: nowrap;
          width: 100%;
          #btn-link {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        /deep/ .flex-between {
          height: 52px;
        }
      }
    }
  }
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  /*filter: blur(10px);*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.o0 {
  opacity: 0;
  width: 100px;
  height: 100px;
  background: url('~img/commonImg/map_bg.jpg');
}
</style>
